import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledWrapper = styled.div`
    margin: ${spaceMixin('sm')} auto;
    width: 200px;

    ${mediaMixin('lg', css`
        margin: ${spaceMixin('lg')} auto;
    `)};
`;
